<template>
  <div
    v-if="overlay && show"
    class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50"
  >
    <div class="bg-white rounded-lg p-6 shadow-xl">
      <div class="text-center">
        <div :class="spinnerClasses"></div>
        <p v-if="text" class="mt-4 text-gray-600 font-medium">{{ text }}</p>
      </div>
    </div>
  </div>

  <span v-else-if="show" :class="spinnerClasses" role="status" aria-label="Cargando"></span>
</template>

<script setup>
import { computed } from "vue";

const props = defineProps({
  show: {
    type: Boolean,
    default: true,
  },
  size: {
    type: String,
    default: "md",
    validator: (value) => ["xs", "sm", "md", "lg", "xl"].includes(value),
  },
  color: {
    type: String,
    default: "primary",
    validator: (value) => ["primary", "secondary", "white", "gray"].includes(value),
  },
  overlay: {
    type: Boolean,
    default: false,
  },
  text: {
    type: String,
    default: "",
  },
  center: {
    type: Boolean,
    default: false,
  },
});

const spinnerClasses = computed(() => {
  const classes = ["animate-spin rounded-full border-solid inline-block flex-shrink-0"];

  const sizeClasses = {
    xs: "w-4 h-4 border-2",
    sm: "w-5 h-5 border-2",
    md: "w-8 h-8 border-2",
    lg: "w-12 h-12 border-3",
    xl: "w-16 h-16 border-4",
  };
  classes.push(sizeClasses[props.size]);

  const colorClasses = {
    primary: "border-primary-200 border-t-primary-600",
    secondary: "border-gray-200 border-t-gray-600",
    white: "border-white/30 border-t-white",
    gray: "border-gray-300 border-t-gray-700",
  };
  classes.push(colorClasses[props.color]);

  return classes.join(" ");
});
</script>
